// extracted by mini-css-extract-plugin
module.exports = {"map":"NotFound_map__3SfDO","wrapper":"NotFound_wrapper__vPNlL","text":"NotFound_text__1iJKP"};